import type { MouseEvent } from 'react';
import type { MenuItem } from 'primereact/menuitem';

export function navigationMenuItem(label: string, icon: string, url: string,
    navigate: (path: string) => void, onNavigate?: () => void): MenuItem {
    return {
        label, icon, url,
        command: ({ originalEvent }) => {
            const event = originalEvent as MouseEvent;
            if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey
                || (typeof event.button === 'number' && event.button !== 0)) return;
            event.preventDefault();
            navigate(url);
            onNavigate?.();
        },
    };
}
